import moment from 'moment'

interface IProps {
  date: string
}

export const HistoryDate: React.FC<IProps> = ({ date }) => {
  return <div className='text-[0.7em] text-text-muted pl-[10px]'>{moment(date).format('ddd Do MMM YY @ hh:mm a')}</div>
}
